import React, { useState } from "react";
import Draggable from "react-draggable";

const ErrorLog = ({ logData, onCancel }) => {
    const [openIndexes, setOpenIndexes] = useState([0]);

    const toggle = index => {
        setOpenIndexes(prev => (prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]));
    };

    const formatLogs = data => {
        if (!Array.isArray(data)) return [];

        return data?.map(item => {
            const attempt = item?.attempt_no || "-";

            let parsed = {};
            try {
                parsed = JSON.parse(item?.handler_traceback || "{}");
            } catch {
                parsed = {};
            }

            const itemEntries = Object.entries(item || {});
            const parsedEntries = Object.entries(parsed || {});

            const combinedEntries = [...itemEntries, ...parsedEntries.filter(([key]) => key !== "handler_traceback")];

            return {
                attempt,
                fields: combinedEntries.map(([key, value]) => ({
                    key,
                    value: typeof value === "object" ? JSON.stringify(value, null, 2) : value
                }))
            };
        });
    };

    const formattedLogs = formatLogs(logData);
    return (
        <div className="modal d-block error-log-popup">
            <Draggable cancel=".not-draggable" handle=".draggable">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title">
                                <div className="txt-hed">Error Logs</div>
                            </h5>
                            <button type="button" className="close" onClick={onCancel}>
                                <span>
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>

                        <div className="modal-body bg-white" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                            {formattedLogs.length ? (
                                formattedLogs.map((log, index) => (
                                    <div key={index} className="card mb-3 shadow-sm border">
                                        <div
                                            className="card-header d-flex justify-content-between align-items-center"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => toggle(index)}
                                        >
                                            <span className="fw-semibold fs-5">
                                                Attempt {index + 1}
                                                {openIndexes.includes(index) ? (
                                                    <i className="fas fa-chevron-up"></i>
                                                ) : (
                                                    <i className="fas fa-chevron-down"></i>
                                                )}
                                            </span>
                                        </div>

                                        {openIndexes.includes(index) && (
                                            <div className="card-body">
                                                {log.fields.map((f, i) => (
                                                    <div key={i} className="mb-3 p-3 rounded border bg-white">
                                                        <div className="mb-1 fw-semibold fs-6 text-primary">
                                                            {f?.key ? f?.key?.charAt(0)?.toUpperCase() + f?.key?.slice(1) : ""}
                                                        </div>

                                                        <div className="text-break fs-5 fw-semibold">{f.value}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="text-center text-muted py-5 fs-5">No Logs Found</div>
                            )}
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default ErrorLog;
